const Background = ({ children, style }) => {
    return (
        <div
            elevation={0}
            style={{
                backgroundColor: "white",
                // overflow: "hidden",
                position: "relative",
                borderRadius: "16px",
                border: '1px solid #E4E4E7',
                padding: 0,
                ...style
            }}
        >
            {children}
        </div>
    )
}

export default Background